import { Routes } from '@angular/router';
import { RoleByFeature } from '@core/configurations/roles.config';
import { authGuard } from '@core/guards/auth.guard';
import { CallbackSigninComponent } from '@core/components/callback-signin/callback-signin.component';
import { CallbackSignoutComponent } from '@core/components/callback-signout/callback-signout.component';
import { LoginComponent } from '@core/components/login/login.component';
import { BaseAppComponent } from '@core/components/base-app/base-app.component';
import { SystemMonitoringComponent } from '@features/system-monitoring/components/system-monitoring/system-monitoring.component';
import { externalRedirectionGuard } from '@core/guards/external-redirection/external-redirection.guard';
import { loginCanMatch } from '@core/guards/login.canmatch';
import { ResetPasswordComponent } from '@core/components/reset-password/reset-password.component';
import { ForgotPasswordComponent } from '@core/components/forgot-password/forgot-password.component';
import { uploadOnlyGuard } from '@core/guards/upload-only.guard';
import { UploadLayoutComponent } from '@core/components/upload-layout/upload-layout.component';
import { uploadFilesLoginGuard } from '@core/guards/upload-files-login.guard';
import { rootRedirectGuard } from '@core/guards/root-redirect.guard';
import { EmptyComponent } from '@core/components/empty/empty.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: EmptyComponent,
    canActivate: [rootRedirectGuard],
  },

  {
    path: 'login',
    component: LoginComponent,
    canMatch: [loginCanMatch],
    data: { loginMode: 'default' },
  },
  {
    path: 'upload-files',
    component: LoginComponent,
    canMatch: [uploadFilesLoginGuard],
    data: { loginMode: 'upload-files' },
  },

  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset', component: ResetPasswordComponent },

  { path: 'callback-signin', component: CallbackSigninComponent },
  { path: 'callback-signout', component: CallbackSignoutComponent },

  {
    path: 'upload',
    component: UploadLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [uploadOnlyGuard],
    loadChildren: () =>
      import('./features/upload-files/upload-files.routes').then(
        (m) => m.uploadFilesRoutes,
      ),
  },

  {
    path: '',
    component: BaseAppComponent,
    canActivateChild: [uploadOnlyGuard],
    children: [
      {
        path: 'home',
        data: {
          breadcrumb: 'menu.home.breadcrumb',
          subtitle: 'menu.home.bannerSubtitle',
        },
        loadChildren: () =>
          import('./features/home/home.routes').then((m) => m.homeRoutes),
        canActivate: [authGuard],
      },

      {
        path: 'administration',
        data: {
          breadcrumb: 'menu.administration.breadcrumb',
          title: 'menu.administration.title',
          roles: RoleByFeature.ADMINISTRATION,
        },
        loadChildren: () =>
          import('./features/administration/administration.routes').then(
            (m) => m.administrationRoutes,
          ),
        canActivate: [authGuard],
      },

      {
        path: 'activity',
        data: {
          breadcrumb: 'menu.activity.breadcrumb',
          title: 'menu.activity.title',
          roles: RoleByFeature.ACTIVITY,
        },
        loadChildren: () =>
          import('./features/activity/activity.routes').then(
            (m) => m.activityRoutes,
          ),
        canActivate: [authGuard],
      },

      {
        path: 'system-monitoring',
        component: SystemMonitoringComponent,
        data: { roles: RoleByFeature.SYSTEM_MONITORING },
        canActivate: [authGuard, externalRedirectionGuard],
      },

      {
        path: 'audit',
        data: {
          breadcrumb: 'menu.audit.breadcrumb',
          title: 'menu.audit.title',
          roles: RoleByFeature.AUDIT,
        },
        loadChildren: () =>
          import('./features/audit/audit.routes').then((m) => m.auditRoutes),
        canActivate: [authGuard],
      },

      {
        path: 'equipment-management',
        data: {
          breadcrumb: 'menu.equipment-management.breadcrumb',
          title: 'menu.equipment-management.title',
          roles: RoleByFeature.EQUIPMENT_MANAGEMENT,
        },
        loadChildren: () =>
          import(
            './features/equipment-management/equipment-management.routes'
          ).then((m) => m.equipmentManagementRoutes),
        canActivate: [authGuard],
      },

      { path: '**', redirectTo: 'home' },
    ],
  },
];
